import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, description, testid }) => (
  <section data-testid={testid} className="relative overflow-hidden border-b border-gold/10 bg-navy/30 pb-16 pt-36 sm:pb-20 sm:pt-44">
    <div
      className="pointer-events-none absolute -top-40 right-0 h-[480px] w-[480px] rounded-full opacity-[0.07]"
      style={{ background: "radial-gradient(circle, #C7A45B 0%, transparent 65%)" }}
      aria-hidden="true"
    />
    <div className="container-x">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="eyebrow"
      >
        {eyebrow}
      </motion.p>
      <span className="mt-4 block overflow-hidden">
        <motion.h1
          initial={{ y: "108%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-ivory sm:text-6xl"
        >
          {title}
        </motion.h1>
      </span>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-steel sm:text-lg"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
